import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthActions } from './auth.actions';
import { UserProfile } from '@lyceo/shared/auth/util-models';
import * as AuthSelectors from './auth.selectors';

@Injectable({
  providedIn: 'root',
})
export class AuthFacade {
  private readonly store: Store = inject(Store);

  public isAuthenticated: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectIsAuthenticated,
  );
  public loginError: Signal<string | null> = this.store.selectSignal(
    AuthSelectors.selectLoginError,
  );
  public hasLoginError: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectHasLoginError,
  );
  public isDoneLoading: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectIsDoneLoading,
  );
  public userProfile: Signal<UserProfile | undefined> = this.store.selectSignal(
    AuthSelectors.selectUserProfile,
  );
  public userId: Signal<string | undefined> = this.store.selectSignal(
    AuthSelectors.selectUserId,
  );
  public userEmail: Signal<string | undefined> = this.store.selectSignal(
    AuthSelectors.selectUserEmail,
  );
  public userFullName: Signal<string | undefined> = this.store.selectSignal(
    AuthSelectors.selectUserFullName,
  );
  public userRoles: Signal<string[]> = this.store.selectSignal(
    AuthSelectors.selectUserRoles,
  );
  public showLoader: Signal<boolean> = this.store.selectSignal(
    AuthSelectors.selectShowLoader,
  );

  public login(kcIdpHint?: 'entree'): void {
    this.store.dispatch(AuthActions.login({ kcIdpHint }));
  }

  public mobileTryLogin(urlSearch: string): void {
    this.store.dispatch(AuthActions.mobileTryLogin({ urlSearch }));
  }

  public mobileLogoutFinish(): void {
    this.store.dispatch(AuthActions.mobileLogoutFinish());
  }

  public userLogout(): void {
    this.store.dispatch(AuthActions.userLogout());
  }

  public retryLoadDiscoveryDocument(): void {
    this.store.dispatch(AuthActions.retryLoadDiscoveryDocument());
  }
}
